import React, { Component } from 'react';
import { general } from '../../data';

class HowTo extends Component {
  render() {
    const instructions = this.props.text.map((item, i) => {
      return <li key={ i }>{ item }</li>
    });

    return (
      <div className="gm-slide__how-to">
        <img className="gm-slide--how-to__intro-image" src={this.props.image} />
        <h4 className="gm-slide--how-to__subtitle"> { this.props.title } </h4>
        <ol className="gm-slide--how-to__list">{ instructions }</ol>
      </div>
    );
  }
}

export default HowTo;



// WEBPACK FOOTER //
// ./src/components/Slides/HowTo.js